module.exports = __webpack_public_path__ + "f34ae7d9135f30460f6dbb8ac558925d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-jungle.png
// module id = 3440
// module chunks = 0